module.exports = "https://static.energy5.com/_next/static/images/ourVisionImage-a02fcfa6371655548ed10c3e79d6ec16.jpg";